<div class="modal-header" #headerDiv>
  <div>
    <h6 class="modal-title">
      <ng-content></ng-content>
    </h6>
  </div>
  <div *ngIf="showClose" class="clickable" (click)="closeClick.next()">
    <i class="fa-regular fa-xmark mx-2"></i>
  </div>
</div>
